import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.css';
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl';
import ProfilePicture from 'components/ProfilePicture';
const messages = defineMessages({
  sendMsg: {
    id: 'FD_PlsEnterStatusMessage',
    defaultMessage: '請輸入您的動態訊息',
  },
});
class PersonalStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content.content,
    };

    this.onInputChange = this.onInputChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.content && this.state.content !== nextProps.content.content) {
      this.setState({
        content: nextProps.content.content,
      });
    }
  }

  onInputChange(event) {
    this.setState({ content: event.target.value });
    if (this.props.onContentChange) {
      this.props.onContentChange(event.target.value);
    }
  }

  render() {
    const {
      photoImgUrl,
      content,
    } = this.props;

    return (
      <div className="personal-status">
        <div className="image-container">
          <ProfilePicture
            className="personal-status__picture"
            loadedPicture={photoImgUrl}
          />
        </div>
        <div className="uploader-btn" onClick={this.props.onFileItemClick}>
          <i className="fa fa-camera" aria-hidden="true" style={{ marginRight: 5 }}></i>
          <FormattedMessage id="FD_ChangePhoto" defaultMessage="更改個人大頭照" />
        </div>
        <form className="content-form">
          <input
            type="text"
            className="form-control"
            placeholder={this.props.intl.formatMessage(messages.sendMsg)}
            value={ this.state.content }
            onChange={ this.onInputChange }
          />
          <i
            className={
              classNames({
                'fa': true,
                'fa-spinner': content.isUpdating,
                'fa-spin': true,
              })
            }
          >
          </i>
        </form>
      </div>
    );
  }
}

PersonalStatus.propTypes = {
  photoImgUrl: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  onContentChange: PropTypes.func.isRequired,
  onFileItemClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(PersonalStatus);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/components/PersonalStatus/index.js
 **/